export default __webpack_public_path__ + "static/media/stage_metis_quintet.7c44ecdb.pdf";